import messages from '@intlify/unplugin-vue-i18n/messages'
import { createI18n } from 'vue-i18n'
import { usePreferenceStore } from '@/stores/preferenceStore'

let store = null

try {
  store = usePreferenceStore()
} catch (error) {
  store = null
}

const locale = computed(() => {
  if (store !== null && store.preferences?.language !== undefined)
    return store.preferences.language
  return 'en'
})

if (messages) {
  messages['de']['activity'] = messages['activity-de']
  messages['en']['activity'] = messages['activity-en']
  messages['fr']['activity'] = messages['activity-fr']
  messages['de']['datasources'] = messages['datasources-de']
  messages['en']['datasources'] = messages['datasources-en']
  messages['fr']['datasources'] = messages['datasources-fr']

  messages['de']['currency'] = messages['currency-de']
  messages['en']['currency'] = messages['currency-en']
  messages['fr']['currency'] = messages['currency-fr']
}

const i18n = createI18n({
  locale: locale.value,
  fallbackLocale: 'en',
  legacy: false,
  globalInjection: true,
  messages,
})

export default i18n
